import React, { useEffect, useContext, useState } from 'react'
import styles from './ResumenADN.module.css'

//Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Popup from '../../components/Modals'
import Cotizacion from './components/cotizacion'
import Coberturas from './components/coberturas'
import Graficos from './components/graficos'

//Services
import * as ADNRepository from "../../services/repositories/adn-repository";
import * as CotizacionRepository from "../../services/repositories/cotizacion-repository";
import * as SolicitudMultipleRepository from "../../services/repositories/solicitud-multiple-repository";
import * as CoberturaRepository from "../../services/repositories/cobertura-repository";
import * as ProductoRepository from "../../services/repositories/producto-repository";
import * as ExclusionRepository from "../../services/repositories/exclusion-repository";
import * as SolicitudRepository from "../../services/repositories/solicitud-repository";
import * as RequisitoRepository from "../../services/repositories/requisito-repository";
import * as UsuarioRepository from "../../services/repositories/usuario-repository";

//Context
import GeneralContext from '../../context/GeneralContext'

//Actions
import * as GeneralActions from '../../store/actions/generalActions'

// Custom Components
import Modal from './components/modal'
import Collapse from './components/collapse'
import TableCotizacion from './components/table-cotizacion'

import * as Funciones from '../../utils/funciones'
import * as Constantes from '../../utils/constantes'
import Brokers from './components/brokers/brokers'

const arrHeadingPriorizadas = [
    'Nro.',
    'Producto',
    'Suma Asegurada'
]

const ResumenADN = ({ history }) => {
    const initialState = {
        estaCargando: true,
        errorCargando: null,
        cotizaciones: null,
        cotizacionPrioritaria: null,
        currentCotizacion: null,
        arrChangeCotizacion: null,
        pieChart: null,
        codigoEstado: null,
        errorCargandoEstado: null,
        beneficios: null,
        exclusiones: null,
        textosLegales: null,
        broker: null,
        codigoBroker: null,
        intermediarioRequest: {
            codigoIntermediario: null,
            codigoAgencia: null,
            codigoOficina: null,
            codigoModalidad: null,
            correoElectronico: null,
            descripcionAgencia: null,
            nombreRazonSocial: null,
            telefonoFijo: null,
            telefonoMovil: null
        },
        codigoOk: false,
        validacionCodigo: false,
        validacionNoBroker: false
    }

    const [codigoEstado, setCodigoEstado] = useState(null)

    const [openId, setOpenId] = useState(1)
    const [state, setState] = useState(initialState)
    const [openModal, setOpenModal] = useState(false)
    const [openConfirmModal, setOpenConfirmModal] = useState(false)
    const [selectedsRows, setSelectedsRows] = useState(null)
    const [selectedsRowsPrev, setSelectedsRowsPrev] = useState(1)
    const [loadedPieChart, setLoadedPieChart] = useState(false)
    const [tabSelect, setTabSelect] = useState(1)
    const [openBroker, setOpenBroker] = useState(false)

    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)

    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
    let cotizacion = prospecto.cotizaciones !== undefined && prospecto.cotizaciones !== null
        ? prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]
        : undefined

    const textos = [
        '¡Alerta!',
        'La venta ya ha sido procesada.'
    ]

    const textoTestInversion = [
        '¡Alerta!',
        'Se debe llenar el Test de Inversión del prospecto para iniciar la solicitud.'
    ]

    const [mostrarModal, setModal] = useState(false)
    const [mostrarModalTestInversion, setModalTestInversion] = useState(false)

    const handleCambiarCotizacion = () => {
        if (state.errorCargando) return
        setOpenModal(true)
    }

    // ACA EMPIEZA TODO
    const requestAdn = async () => {
        const responseAdn = await ADNRepository.obtenerADN(prospecto.idProspecto)
        if (responseAdn.error === null) {
            setState((state) => {
                return {
                    ...state,
                    pieChart: responseAdn.adn,
                }
            })
            setLoadedPieChart(true)
            generalDispatch(GeneralActions.updateError(null, null, false))
            return true
        } else {
            generalDispatch(GeneralActions.updateError({ mensajeRespuesta: 'Revisa los datos del ADN del prospecto.'}, 'ADN incompleto', true, undefined, undefined, '', () => { history.push('/') }))
            return false
        }
    }

    const obtenerCotizaciones = async () => {
        const response = await CotizacionRepository.listarCotizaciones(prospecto.idProspecto)
        if (response.error === null) {
            let cotizacionPrioritaria = null
            let listaCotizaciones = []
            let cotizacionSalida = null

            response.cotizaciones.map((cotizacionRes) => {
                //Busca Cotizacion Prioritaria
                if (cotizacionPrioritaria) {
                    if (cotizacionPrioritaria.nivelPriorizacion > cotizacionRes.nivelPriorizacion &&
                        cotizacionRes.nivelPriorizacion > 0 &&
                        cotizacionRes.codigoEstado !== Constantes.COD_ESTADO_SOLICITUD_PAGO_SIN_FIRMA) {
                            cotizacionPrioritaria = cotizacionRes
                    }
                } else {
                    if(cotizacionRes.codigoEstado !== Constantes.COD_ESTADO_SOLICITUD_PAGO_SIN_FIRMA) {
                        cotizacionPrioritaria = cotizacionRes
                    }
                }
                //Buscar en cotizaciones actuales
                let cotizacionAux = {}
                if (prospecto.listaCotizaciones !== null && prospecto.listaCotizaciones !== undefined) {
                    prospecto.listaCotizaciones.map(cotizacionPros => {
                        if (cotizacionPros.codigoCotizacion.toString() === cotizacionRes.codigoCotizacion.toString()) {
                            cotizacionAux = {
                                ...cotizacionPros
                            }
                        }
                        return cotizacionRes
                    })
                }

                listaCotizaciones.push({
                    ...cotizacionAux,
                    codigoCotizacion: cotizacionRes.codigoCotizacion,
                    idSolicitudMultiple: cotizacionRes.idSolicitudMultiple,
                    codigoEstado: cotizacionRes.codigoEstado
                })

                return cotizacionRes
            })

            setSelectedsRows(cotizacion !== undefined ? cotizacion.codigoCotizacion : response.cotizaciones[0].codigoCotizacion)
            generalDispatch(GeneralActions.setCotizaciones(listaCotizaciones))

            setState((state) => {
                return {
                    ...state,
                    cotizaciones: response.cotizaciones,
                    cotizacionPrioritaria: cotizacionPrioritaria
                }
            })

            if (cotizacion !== undefined) {
                cotizacionSalida = cotizacion
            } else {
                cotizacionSalida = cotizacionPrioritaria
            }

            generalDispatch(GeneralActions.updateError(null, null, false))
            await obtenerEstadoSolicitudMultiple(cotizacionSalida)
            return cotizacionSalida
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
            return null
        }
    }

    const obtenerEstadoSolicitudMultiple = async (cotizacion) => {
        if(cotizacion !== null && cotizacion.codigoEstado !== 0) {
            const response = await SolicitudMultipleRepository.obtenerEstadoSolicitudMultiple(cotizacion.idSolicitudMultiple)
            if (response.error === null) {
                setState((state) => {
                    return {
                        ...state,
                        errorCargandoEstado: false,
                        codigoEstado: response.estado.codigo
                    }
                })
                setCodigoEstado(response.estado.codigo)
                generalDispatch(GeneralActions.updateError(null, null, false))
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
            }
        }
    }

    const obtenerProspectoPorCodigo = async (cotizacion) => {
        const response = await CotizacionRepository.obtenerCotizacionxProspecto(prospecto.idProspecto, cotizacion.codigoCotizacion)
        if (response.error === null) {
            generalDispatch(
                GeneralActions.setDatosInicialesCotizacion(
                    response.cotizacion.codigoCotizacion.toString(),
                    response.cotizacion.esDistintoAsegurado,
                    response.cotizacion.esAPFamiliar,
                    response.cotizacion.requiereFirmaConyuge,
                    response.cotizacion.requiereIngresoHijos,
                    response.cotizacion.productos
                )
            )

            setState((state) => {
                return {
                    ...state,
                    currentCotizacion: response.cotizacion,
                    errorCargando: null
                }
            })
            generalDispatch(GeneralActions.updateError(null, null, false))
            await obtenerAliasCobertura(response.cotizacion)
            return true
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
            return false
        }
    }

    const obtenerAliasCobertura = async (cotizacion) => {
        const response = await CoberturaRepository.obtenerAliasCoberturas(cotizacion.productos)
        if (response.error === null) {
            let nuevoProd = cotizacion.productos.map(producto => {
                let alias = []
                response.aliasCoberturas.listAliasCoberturaCliente.map(lista => {
                    if (producto.codigoProducto === lista.codigoProducto) {
                        alias.push(lista)
                        producto.listaAlias = alias
                    }
                    return lista
                })
                return producto
            })

            setState((state) => {
                return {
                    ...state,
                    listaAlias: response.aliasCoberturas.listAlias,
                    listaCoberturasAlias: response.aliasCoberturas.listAliasCoberturaCliente,
                    productoCoberturas: nuevoProd
                }
            })

            generalDispatch(GeneralActions.updateError(null, null, false))
            await obtenerTextosCobertura(cotizacion)
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }
    }

    const obtenerTextosCobertura = async (cotizacion) => {
        const response = await CoberturaRepository.obtenerTextosCoberturas(cotizacion.productos)
        if (response.error === null) {
            setState((state) => {
                return {
                    ...state,
                    estaCargando: false,
                    textoCoberturas: response.textosCoberturas
                }
            })
            generalDispatch(GeneralActions.updateError(null, null, false))
            await obtenerBeneficiosPorProducto(cotizacion)
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }
    }

    const obtenerBeneficiosPorProducto = async (cotizacion) => {
        if (cotizacion.beneficiosAdicionales !== undefined && cotizacion.beneficiosAdicionales !== null && cotizacion.beneficiosAdicionales !== '') {//TODO: cambiar 1
            const response = await ProductoRepository.obtenerBeneficiosProducto(cotizacion.beneficiosAdicionales)
            if (response.error === null) {
                generalDispatch(GeneralActions.guardarBeneficios(response.beneficios));
                setState((state) => {
                    return {
                        ...state,
                        beneficios: response.beneficios,
                        estaCargando: false,
                        errorCargando: null
                    }
                })

                generalDispatch(GeneralActions.updateError(null, null, false))
                await obtenerExclusiones(cotizacion)
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
            }
        } else {
            await obtenerExclusiones(cotizacion)
        }
    }

    const obtenerExclusiones = async (cotizacion) => {
        const response = await ExclusionRepository.obtenerBeneficiosProducto(cotizacion.productos)
        if (response.error === null) {
            const exclusionesSinDuplicados = response.exclusiones.reduce(function (p, c) {
                if (!p.some(function (el) { return el.idExclusion === c.idExclusion; })) p.push(c);
                return p;
            }, []);
            generalDispatch(GeneralActions.guardarExclusiones(exclusionesSinDuplicados));

            setState((state) => {
                return {
                    ...state,
                    exclusiones: exclusionesSinDuplicados,
                    estaCargando: false,
                    errorCargando: null
                }
            })

            generalDispatch(GeneralActions.updateError(null, null, false))
            await getTextosLegales(cotizacion)
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }
    }

    const getTextosLegales = async (cotizacion) => {
        const response = await ProductoRepository.obtenerTextosLegales(cotizacion.productos)
        if (response.error === null) {
            setState((state) => {
                return {
                    ...state,
                    estaCargando: false,
                    errorCargando: null,
                    textosLegales: response.textosLegales
                }
            })
            generalDispatch(GeneralActions.updateError(null, null, false))
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }
    }

    const cargarDatosIniciales = async () => {
        generalDispatch(GeneralActions.updateEstadoCargando(true))
        let salida = await requestAdn()
        if (salida) {
            let cotizacionSalida = await obtenerCotizaciones()
            if (cotizacionSalida !== null) {
                await obtenerProspectoPorCodigo(cotizacionSalida)
            }
        }
        generalDispatch(GeneralActions.updateEstadoCargando(false))
    }
    // FIN REFACTOR

    useEffect(() => {
        cargarDatosIniciales()
    }, [])

    const onCancelModal = () => {
        setOpenModal(false)
    }

    const onSuccessModal = () => {
        return window.open(process.env.REACT_APP_URL_COTIZADOR)
    }

    const onSelectRow = (id) => {
        setSelectedsRowsPrev(id)
        setOpenModal(false)
        setOpenConfirmModal(true)
    }

    const onCancelModalConfirm = () => {
        setOpenConfirmModal(false)
        setOpenModal(true)
    }

    const onSuccessModalConfirm = async () => {
        setState((state) => {
            return {
                ...state,
                estaCargando: true,
                errorCargando: null
            }
        })

        setTabSelect(1)
        setOpenConfirmModal(false)
        setSelectedsRows(selectedsRowsPrev)
        setOpenModal(false)

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        let salida = await requestAdn()
        if (salida) {
            salida = await obtenerProspectoPorCodigo({ codigoCotizacion: selectedsRowsPrev })
            if (salida && cotizacion.idSolicitudMultiple !== 0) {
                await obtenerEstadoSolicitudMultiple(cotizacion)
            }
        }
        generalDispatch(GeneralActions.updateEstadoCargando(false))
    }

    const continuarSinBroker = async () => {
        let existeProductoInversion = false
        state.currentCotizacion.productos.map(producto => {
            if (Constantes.COD_TIPO_PRODUCTO_VIDA_INVERSION === producto.codigoTipoProducto) {
                existeProductoInversion = true
            }
            return producto
        })

        if (state.pieChart !== null && !state.pieChart.flagTestInversion && existeProductoInversion) {
            //CAMUNOZR: Mostrar popup porque Prospecto no tiene el Test de Inversión finalizado.
            setOpenBroker(false)
            setState((state) => {
                return {
                    ...state,
                    broker: null,
                    codigoBroker: null,
                    validacionCodigo: false,
                    validacionNoBroker: false,
                    codigoOk: false,
                    intermediarioRequest: {
                        codigoIntermediario: null,
                        codigoAgencia: null,
                        codigoOficina: null,
                        codigoModalidad: null,
                        correoElectronico: null,
                        descripcionAgencia: null,
                        nombreRazonSocial: null,
                        telefonoFijo: null,
                        telefonoMovil: null
                    }
                }
            })
            generalDispatch(GeneralActions.updateEstadoCargando(false))
            setModalTestInversion(true)//TODO: Mostrar Error
        } else {
            //Cotizacion Cambiada
            let cotizacion2 = state.cotizaciones.filter(cotizacion => cotizacion.codigoCotizacion.toString()
                === state.currentCotizacion.codigoCotizacion.toString())[0]
            
            //Condiciones de validación por código estado cotización
            if (cotizacion2.codigoEstadoCotizacion === 1 || cotizacion2.codigoEstadoCotizacion === 4) {
                //CMUNAYLLA: se agrega condición para validar si tiene estado firmado sin pago/pago incompleto/firma en espera
                if (cotizacion2.codigoEstado === 2 || cotizacion2.codigoEstado === 6 || cotizacion2.codigoEstado === 8 
                    || cotizacion2.codigoEstado === 12 || (cotizacion2.codigoEstado === 9 && cotizacion2.estadoFirma === '6')) {
                    const resRequisitos = await RequisitoRepository.obtenerRequisitos(cotizacion.idSolicitudMultiple)
                    if (resRequisitos.error === null) {
                        generalDispatch(GeneralActions.setRequisitosIniciales(resRequisitos.requisitos))
                        generalDispatch(GeneralActions.updateEstadoProspecto())
                        generalDispatch(GeneralActions.continuarProceso('/resumenADN'))
                    } else {
                        generalDispatch(GeneralActions.updateError(resRequisitos.error, '¡Alerta!', true))
                        return false
                    }
                }

                if (cotizacion2 === undefined || cotizacion2 === null || cotizacion2.idSolicitudMultiple === 0) {
                    const responseSolicitudMultiple = await SolicitudMultipleRepository.registrarSolicitudMultiple(user.info.CodigoIntermediario,
                        prospecto.idProspecto, state.currentCotizacion.codigoCotizacion, user.info.IdUsuario,
                        state.intermediarioRequest, state.broker)
                    if (responseSolicitudMultiple.error === null) {
                        const responseSolicitudes = await SolicitudRepository.obtenerSolicitudes(responseSolicitudMultiple.solicitudMultiple.idSolicitudMultiple)
                        if (responseSolicitudes.error === null) {
                            generalDispatch(GeneralActions.agregarCodAgencia(responseSolicitudes.solicitudes.codigoAgencia))
                            generalDispatch(
                                GeneralActions.setSolicitudProspecto(
                                    responseSolicitudMultiple.solicitudMultiple.idSolicitudMultiple,
                                    responseSolicitudes.solicitudes.solicitudes,
                                    responseSolicitudes.solicitudes.productos,
                                    responseSolicitudes.solicitudes.flagDeclaracionJurada
                                )
                            )
                            if (!state.currentCotizacion.esDistintoAsegurado) {
                                generalDispatch(GeneralActions.eliminarOpcionMenu('/informacion/contratante'))
                            }
                            return true
                        } else {
                            generalDispatch(GeneralActions.updateError(responseSolicitudes.error, '¡Alerta!'))
                            return false
                        }
                    } else {
                        generalDispatch(GeneralActions.updateError(responseSolicitudMultiple.error, '¡Alerta!'))
                        return false
                    }
                } else {
                    //CMUNAYLLA: condicional para validar codigos de estado
                    if (cotizacion2.codigoEstado === 1 || cotizacion2.codigoEstado === 2 || cotizacion2.codigoEstado === 6 ||
                        cotizacion2.codigoEstado === 8 || cotizacion2.codigoEstado === 12 || 
                        (cotizacion2.codigoEstado === 9 && cotizacion2.estadoFirma === '6')) {
                        //Se setea el limpiado del submenu
                        generalDispatch(GeneralActions.limpiarProceso())
    
                        const responseSolicitudes = await SolicitudRepository.obtenerSolicitudes(cotizacion.idSolicitudMultiple)
                        if (responseSolicitudes.error === null) {
                            generalDispatch(
                                GeneralActions.setSolicitudProspecto(
                                    cotizacion.idSolicitudMultiple,
                                    responseSolicitudes.solicitudes.solicitudes,
                                    responseSolicitudes.solicitudes.productos,
                                    responseSolicitudes.solicitudes.flagDeclaracionJurada
                                )
                            )
                            generalDispatch(GeneralActions.agregarCodAgencia(responseSolicitudes.solicitudes.codigoAgencia))
                            generalDispatch(GeneralActions.updateLpdpProspecto(responseSolicitudes.solicitudes.marcaLpdp, responseSolicitudes.solicitudes.marcaAdicionalLpdp, codigoEstado))
                            if (!state.currentCotizacion.esDistintoAsegurado) {
                                generalDispatch(GeneralActions.eliminarOpcionMenu('/informacion/contratante'))
                            }
    
                            //Seteamos los valores ya guardados del servicio al context para ser mostrados (estados 2, 6 y 12)
                            if (cotizacion2.codigoEstado === 2 || cotizacion2.codigoEstado === 6 || 
                                cotizacion2.codigoEstado === 8 || cotizacion2.codigoEstado === 12 ||
                                (cotizacion2.codigoEstado === 9 && cotizacion2.estadoFirma === '6')) {
                                generalDispatch(GeneralActions.updateLpdpProspecto(responseSolicitudes.solicitudes.marcaLpdp, responseSolicitudes.solicitudes.marcaAdicionalLpdp, state.codigoEstado))
                                generalDispatch(GeneralActions.updateAseguradoProspecto(responseSolicitudes.solicitudes.preguntas, responseSolicitudes.solicitudes.subPreguntas))
                                generalDispatch(GeneralActions.updateAseguradoAdicionalProspecto(responseSolicitudes.solicitudes.preguntas, responseSolicitudes.solicitudes.subPreguntas))
                                generalDispatch(GeneralActions.setAseguradoProspecto(responseSolicitudes.solicitudes.asegurado))
                                generalDispatch(GeneralActions.setContratanteCotizacion(responseSolicitudes.solicitudes.contratante))
                            }
    
                            return true
                        } else {
                            generalDispatch(GeneralActions.updateError(responseSolicitudes.error, '¡Alerta!'))
                            return false
                        }
                    } else if (cotizacion2.codigoEstado !== null) { //Se restringe el acceso al sistema para solicitudes distintas de estado 1, 2, 6, 8 y 12
                        setState((state) => {
                            return {
                                ...state,
                                estaCargando: false
                            }
                        })
                        generalDispatch(GeneralActions.updateError({ mensajeRespuesta: Constantes.MENSAJE_VENTA_REALIZADA }, '¡Alerta!'))
                        return false
                    }
                }
            } else if (cotizacion2.codigoEstadoCotizacion === 2) {
                generalDispatch(GeneralActions.updateError({ mensajeRespuesta: Constantes.MENSAJE_COTIZACION_ELIMINADA }, '¡Alerta!'))
                return false
            } else if (cotizacion2.codigoEstadoCotizacion === 3) {
                generalDispatch(GeneralActions.updateError({ mensajeRespuesta: Constantes.MENSAJE_COTIZACION_VENCIDA }, '¡Alerta!'))
                return false
            }
        }
    }

    const onChangeTab = (idTab) => {
        setTabSelect(idTab)
    }

    const tieneProyecciones = () => {
        let productos = state.currentCotizacion?.productos
        let salida = true
        if (productos !== undefined && productos !== null) {
            for (let producto of productos) {
                if (Funciones.tieneProyecciones(producto.codigoProducto)) {
                    if (producto.escenarios !== null && producto.escenarios.length > 0 &&
                        producto.escenarios[0].proyecciones !== null && producto.escenarios[0].proyecciones.length > 0) {
                        return true
                    } else {
                        salida = false
                    }
                } else {
                    salida = false
                }
            }
        }
        return salida
    }

    const validarPantalla = async () => {
        let usuario = user.roles[0]
        let continuar = false

        let arrayUsuariosInter = process.env.REACT_APP_COD_ROL_INTER.split(',')
        let userFound = arrayUsuariosInter.find(arr => arr === usuario.CodigoRol)

        let cotizacionAux = state.cotizaciones.filter(cotizacion => cotizacion.codigoCotizacion.toString()
                === state.currentCotizacion.codigoCotizacion.toString())[0]

        if (cotizacionAux.codigoEstado === 0) {
            if (userFound !== undefined) {
                setOpenBroker(true)
            } else {
                continuar = await continuarSinBroker()
            }
        } else {
            continuar = await continuarSinBroker()
        }
        
        return continuar
    }

    const onSuccessBrokerContinuar = async () => {
        generalDispatch(GeneralActions.updateEstadoCargando(true))
        let pasar = await continuarSinBroker()

        if (pasar) {
            generalDispatch(GeneralActions.continuarProceso(history.location.pathname))
            history.push('/informacion/lpdp')
        }
    }

    const obtenerIntermediario = async (event) => {
        event.preventDefault()

        if (state.codigoBroker !== null && state.codigoBroker !== '' && state.codigoBroker !== undefined) {
            generalDispatch(GeneralActions.updateEstadoCargando(true))
            const response = await UsuarioRepository.obtenerIntermediario(state.codigoBroker)
            if (response.error === null) {
                if (response.intermediario.codigoIntermediario !== null) {
                    setState((state) => {
                        return {
                            ...state,
                            estaCargando: false,
                            errorCargando: null,
                            intermediarioRequest: {
                                codigoIntermediario: response.intermediario.codigoIntermediario,
                                codigoAgencia: response.intermediario.codigoAgencia,
                                codigoOficina: response.intermediario.codigoOficina,
                                codigoModalidad: response.intermediario.codigoModalidad,
                                correoElectronico: response.intermediario.correoElectronico,
                                descripcionAgencia: response.intermediario.descripcionAgencia,
                                nombreRazonSocial: response.intermediario.nombreRazonSocial,
                                telefonoFijo: response.intermediario.telefonoFijo.trim(),
                                telefonoMovil: response.intermediario.telefonoMovil.trim()
                            },
                            codigoOk: true,
                            validacionCodigo: false
                        }
                    })
                } else {
                    setState((state) => {
                        return {
                            ...state,
                            estaCargando: false,
                            errorCargando: null,
                            validacionCodigo: true
                        }
                    })
                }
                generalDispatch(GeneralActions.updateEstadoCargando(false))
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
                generalDispatch(GeneralActions.updateEstadoCargando(false))
            }
        } else {
            setState((state) => {
                return {
                    ...state,
                    validacionNoBroker: true
                }
            })
        }
    }

    const onChangeCodigoBroker = (e) => {
        let valor = e.target.value.replace(/\D/g, '')
        setState((state) => {
            return {
                ...state,
                codigoBroker: valor,
                validacionCodigo: false,
                validacionNoBroker: false,
                codigoOk: false,
                intermediarioRequest: {
                    codigoIntermediario: null,
                    codigoAgencia: null,
                    codigoOficina: null,
                    codigoModalidad: null,
                    correoElectronico: null,
                    descripcionAgencia: null,
                    nombreRazonSocial: null,
                    telefonoFijo: null,
                    telefonoMovil: null
                }
            }
        })
    }

    const esSolicitudFinalizada = (codigoEstadoSolicitud) => {
        return (codigoEstadoSolicitud >= Constantes.COD_ESTADO_SOLICITUD_FIRMADA_SIN_PAGO &&
            codigoEstadoSolicitud <= Constantes.COD_ESTADO_SOLICITUD_FIRMA_PENDIENTE)
    }

    return (
        <div>
            <Header history={history} />
            <section style={{ background: '#f8fafb' }}>
                <div className={styles.center}>
                    <div className={styles.div_titulo}>
                        Estás a un solo paso de cambiar tu futuro
                    </div>
                    <div className={styles.div_subtitulo}>
                        Pensando en proteger tu felicidad, queremos que conozcas las soluciones que te hemos preparado.
                    </div>
                </div>

                <div className={styles.flex_container}>
                    {Constantes.TABS_RESUMEN_ADN.map(tab => {
                        let flexSize = Math.floor(100 / Constantes.TABS_RESUMEN_ADN.length) + '%';
                        return (
                            <div
                                key={'tab_' + tab.id}
                                className={styles.flex_item}
                                style={{ flex: flexSize }}
                                onClick={tab.id !== 3 || (tab.id === 3 && tieneProyecciones())
                                    ? () => onChangeTab(tab.id)
                                    : undefined}>
                                <span
                                    className={tabSelect === tab.id ? styles.span_item_select : styles.span_item}
                                    style={tab.id !== 3 || (tab.id === 3 && tieneProyecciones())
                                        ? null
                                        : { 'color': '#d6d8d9' }}>
                                    {tab.descripcion}
                                </span>
                                <div className={tabSelect === tab.id ? styles.rectangle_select : styles.rectangle}></div>
                            </div>
                        )
                    })}
                </div>

                <div className={styles.areaWrap}>
                    {tabSelect === 1
                        ? <Cotizacion
                            estaCargando={state.estaCargando}
                            prospecto={prospecto}
                            pieChart={state.pieChart}
                            loadedPieChart={loadedPieChart}
                            data={state.currentCotizacion && state.currentCotizacion?.productos}
                            retorno={state.currentCotizacion && state.currentCotizacion?.retornos}
                            productos={state.currentCotizacion && state.currentCotizacion?.productos}
                            tipoCambio={state.currentCotizacion && state.currentCotizacion?.exchangeRate}
                            beneficios={state && state?.beneficios}
                            exclusiones={state && state?.exclusiones}
                        />
                        : null
                    }

                    {tabSelect === 2
                        ? <Coberturas
                            productos={state.currentCotizacion && state.currentCotizacion?.productos}
                            textoCoberturas={state.textoCoberturas}
                            prodCobers={state.productoCoberturas}
                        />
                        : null
                    }

                    {tabSelect === 3
                        ? <Graficos
                            productos={state.currentCotizacion && !state.currentCotizacion?.productos ? [] : state.currentCotizacion.productos}
                            textosLegales={state && state?.textosLegales}
                        />
                        : null
                    }
                </div>

                <div className={styles.areaWrap}>
                    <div className={styles['grupobtnavADN']}>
                        <button onClick={handleCambiarCotizacion} className={styles['btncancelarapp']}>
                            Cambiar cotización
                        </button>
                        <Footer
                            history={history}
                            validarPantalla={validarPantalla}
                            tipo='1'
                            disabled={generalState.bloquearFlujo}
                        />
                    </div>
                    <Popup
                        mostrarModal={mostrarModal} setModal={setModal} textos={textos}
                    />
                    <Popup
                        mostrarModal={mostrarModalTestInversion} setModal={setModalTestInversion} textos={textoTestInversion}
                    />
                </div>
            </section>

            {openModal && (
                <Modal
                    onCancelModal={onCancelModal}
                    onSuccessModal={onSuccessModal}
                    title='Cambiar Cotización'
                    buttons={['Volver a cotizar', 'Cancelar']}
                    stylesContentAdd={{paddingTop: '0'}}
                    stylesAdd={{height: '100%', overflow: 'overlay', width: '780px'}}
                >
                    {/* Cotizaciones priorizadas */}
                    <div className={styles.separateTab}>
                        <Collapse
                            title='Cotizaciones priorizadas'
                            id={1}
                            openTab={openId === 1}
                            onTab={() => setOpenId(1)}
                            small
                        >
                            {state.cotizaciones !== null
                                ? state.cotizaciones.filter((e) =>
                                e.nivelPriorizacion !== 0 && e.codigoEstadoCotizacion === 1 && !esSolicitudFinalizada(e.codigoEstado)).length > 0 ? (
                                    <TableCotizacion
                                        tipoGrupo={Constantes.TIPO_COTIZACIONES_PRIORIZADAS}
                                        heading={arrHeadingPriorizadas}
                                        cotizaciones={state.cotizaciones.filter((e) =>
                                            e.nivelPriorizacion !== 0 && e.codigoEstadoCotizacion === 1 && !esSolicitudFinalizada(e.codigoEstado))
                                            .sort((a, b) => a.nivelPriorizacion - b.nivelPriorizacion)}
                                        selectedsRows={selectedsRows}
                                        onSelectRow={onSelectRow}
                                    />
                            ) : (
                                <div style={{ marginLeft: '10px'}}>
                                    No se encontró data
                                </div>
                            ) : null}
                        </Collapse>
                    </div>

                    {/* Cotizaciones no priorizadas */}
                    <div className={styles.separateTab}>
                        <Collapse
                            title='Cotizaciones no priorizadas'
                            id={2}
                            openTab={openId === 2}
                            onTab={() => setOpenId(2)}
                            small
                        >
                            {state.cotizaciones !== null
                                ? state.cotizaciones.filter((e) =>
                                e.nivelPriorizacion === 0 && e.codigoEstadoCotizacion === 1 && !esSolicitudFinalizada(e.codigoEstado)).length > 0 ? (
                                    <TableCotizacion
                                        tipoGrupo={Constantes.TIPO_COTIZACIONES_NO_PRIORIZADAS}
                                        heading={arrHeadingPriorizadas}
                                        cotizaciones={state.cotizaciones.filter((e) =>
                                            e.nivelPriorizacion === 0 && e.codigoEstadoCotizacion === 1 && !esSolicitudFinalizada(e.codigoEstado))}
                                        selectedsRows={selectedsRows}
                                        onSelectRow={onSelectRow}
                                    />
                            ) : (
                                <div style={{ marginLeft: '10px'}}>
                                    No se encontró data
                                </div>
                            ) : null}
                        </Collapse>
                    </div>

                    {/* Cotizaciones Vendidas */}
                    <div className={styles.separateTab}>
                        <Collapse
                            title='Cotizaciones vendidas'
                            id={3}
                            openTab={openId === 3}
                            onTab={() => setOpenId(3)}
                            small
                        >
                            {state.cotizaciones !== null
                                ? state.cotizaciones.filter((e) => esSolicitudFinalizada(e.codigoEstado)).length > 0 ? (
                                    <TableCotizacion
                                        tipoGrupo={Constantes.TIPO_COTIZACIONES_VENDIDAS}
                                        heading={arrHeadingPriorizadas}
                                        cotizaciones={state.cotizaciones.filter((e) =>
                                            esSolicitudFinalizada(e.codigoEstado))}
                                        selectedsRows={selectedsRows}
                                        onSelectRow={onSelectRow}
                                    />
                            ) : (
                                <div style={{ marginLeft: '10px'}}>
                                    No se encontró data
                                </div>
                            ) : null}
                        </Collapse>
                    </div>

                    {/* Cotizaciones Vencidas */}
                    <div className={styles.separateTab}>
                        <Collapse
                            title='Cotizaciones vencidas'
                            id={4}
                            openTab={openId === 4}
                            onTab={() => setOpenId(4)}
                            small
                        >
                            {state.cotizaciones !== null
                                ? state.cotizaciones.filter((e) => e.codigoEstadoCotizacion === 3).length > 0 ? (
                                    <TableCotizacion
                                        tipoGrupo={Constantes.TIPO_COTIZACIONES_VENCIDAS}
                                        heading={arrHeadingPriorizadas}
                                        cotizaciones={state.cotizaciones.filter((e) =>
                                            e.codigoEstadoCotizacion === 3)}
                                        selectedsRows={selectedsRows}
                                    />
                            ) : (
                                <div style={{ marginLeft: '10px'}}>
                                    No se encontró data
                                </div>
                            ) : null}
                        </Collapse>
                    </div>

                    {/* Cotizaciones Eliminadas */}
                    <div className={styles.separateTab}>
                        <Collapse
                            title='Cotizaciones eliminadas'
                            id={5}
                            openTab={openId === 5}
                            onTab={() => setOpenId(5)}
                            small
                        >
                            {state.cotizaciones !== null
                                ? state.cotizaciones.filter((e) => e.codigoEstadoCotizacion === 2).length > 0 ? (
                                    <TableCotizacion
                                        tipoGrupo={Constantes.TIPO_COTIZACIONES_VENCIDAS}
                                        heading={arrHeadingPriorizadas}
                                        cotizaciones={state.cotizaciones.filter((e) =>
                                            e.codigoEstadoCotizacion === 2)}
                                        selectedsRows={selectedsRows}
                                    />
                            ) : (
                                <div style={{ marginLeft: '10px'}}>
                                    No se encontró data
                                </div>
                            ) : null}
                        </Collapse>
                    </div>
                </Modal>
            )}

            {openConfirmModal && (
                <Modal
                    onCancelModal={onCancelModalConfirm}
                    onSuccessModal={onSuccessModalConfirm}
                    title='Cambiar Cotización'
                    titleCenter
                    buttons={['Aceptar', 'Cancelar']}
                >
                    <div className={styles.styleConfirm}>
                        ¿Estás seguro de cambiar de cotización?<br />
                        Se borrarán los datos que no tengan relación con la nueva
                    </div>
                </Modal>
            )}

            {openBroker && (
                <Brokers
                    title='Código Broker'
                    onSuccessBroker={onSuccessBrokerContinuar}
                    state={state}
                    setState={setState}
                    codigoOk={state.codigoOk}
                >
                    {state.broker && (
                        <div className={styles.areaBroker}>
                            <div className={styles.area50}>
                                <label>Ingrese el código broker</label>
                                <form onSubmit={obtenerIntermediario} className={styles['intermediario']}>
                                    <input id="myInput"
                                        type='text'
                                        value={state.codigoBroker !== null ? state.codigoBroker : ''}
                                        onChange={(e) => onChangeCodigoBroker(e)}
                                        maxLength={10}
                                    />
                                    {state.validacionNoBroker &&
                                        <span className={styles['span-error']}>{Constantes.MENSAJE_BROKER_OBLIGATORIO}</span>
                                    }
                                    <button className={styles['lupa']} />
                                </form>
                                
                                {state.validacionCodigo ? 
                                    <span className={styles['span-error']}>
                                        {Constantes.MENSAJE_VALIDACION_BROKER}
                                    </span>
                                    : null
                                }
                                {state.intermediarioRequest.nombreRazonSocial !== undefined && state.intermediarioRequest.nombreRazonSocial !== null
                                    ? 
                                    <div>
                                        <span className={styles['span-error']}>
                                            {Constantes.MENSAJE_BROKER_ENCONTRADO}
                                        </span>
                                        <span className={styles['brokers_name']}>
                                            Nombre: {state.intermediarioRequest.nombreRazonSocial}
                                        </span>
                                    </div>
                                    : null
                                }
                            </div>
                        </div>
                    )}
                </Brokers>
            )}
        </div>
    )
}

export default ResumenADN;